import { ApolloSandbox } from '@apollo/sandbox'

new ApolloSandbox({
  target: '#embedded-apollo-sandbox',
  initialEndpoint: `${window.location.origin}/api/graphql`,
  initialState: {
    pollForSchemaUpdates: false,
  },
})
